import { Colors } from './Colors';
export const Border = {
  color: {
    default: Colors.adamantium,
  },
  radius: {
    default: '3px',
    large: '10px',
  },
  size: {
    default: '1px',
  },
};
